import { useParams } from "@tanstack/react-router";
import { normalizeLocale, type Locale } from "@/lib/i18n";

export function useLocale(): Locale {
  const params = useParams({ strict: false }) as { locale?: string };
  return normalizeLocale(params.locale);
}
